import { values } from "@omni/utils/object.utils";
import { cn } from "@omni/utils/styles";
import { useId } from "react";
import Select from "react-select";

import { useReviewsContext } from "@/components/Product/Reviews/context/reviews.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as UseFeatureTracker from "@/services/tracking/trackers/feature/useFeature.tracker";
import { ReviewsSearchStort } from "@/types/service/reviews/reviews.api";

type ReviewSortSelectOption = {
    value: ReviewsSearchStort;
    label: string;
};

type Props = {
    className?: string;
};

export const Sort = ({ className }: Props) => {
    const { t } = useGranite();

    const { sku, brand, category, sort, setSort } = useReviewsContext();

    const toOption = (value: ReviewsSearchStort) => ({
        value: value,
        label: t(`product.reviews.filters.sort.${value.toString()}`)
    });

    const value = toOption(sort);
    const options = values(ReviewsSearchStort).map(toOption);

    const isSelected = (value: ReviewsSearchStort) => sort === value;

    const handleOnSortChange = (option: ReviewSortSelectOption | null) => {
        if (!option) return;

        UseFeatureTracker.track({
            type: "bazaarvoice",
            name: "sort",
            sku: sku,
            brand: brand,
            categoryId: category,
            direction: option.value
        });

        setSort(option.value);
    };

    const id = useId();

    return (
        <Select
            instanceId={id}
            id={"reviews-sort"}
            openMenuOnFocus={true}
            options={options}
            isSearchable={false}
            blurInputOnSelect={true}
            value={value}
            onChange={handleOnSortChange}
            className={cn(className)}
            classNames={{
                menu: () => cn("tw:overflow-hidden"),
                menuList: () => cn("tw:p-0!"),
                option: ({ data }) =>
                    cn({
                        "tw:border-l-3 tw:border-l-primary tw:bg-grey! tw:text-black!":
                            isSelected(data.value)
                    })
            }}
        />
    );
};
